const STORAGE_KEY = 'bloodeye_notification_settings';

const DEFAULTS = {
    enabled: false,
    reminderTime: '09:00',
    types: { dailyReminder: true, missedDose: true },
    lastReminderFired: null,
};

export function getDefaults() {
    return { ...DEFAULTS, types: { ...DEFAULTS.types } };
}

export function loadSettings() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return getDefaults();
        const parsed = JSON.parse(raw);
        return { ...getDefaults(), ...parsed, types: { ...DEFAULTS.types, ...parsed.types } };
    } catch {
        return getDefaults();
    }
}

export function saveSettings(settings) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

export function isNotificationSupported() {
    return 'Notification' in window && 'serviceWorker' in navigator;
}

export function getPermissionState() {
    if (!('Notification' in window)) return 'unsupported';
    return Notification.permission; // 'default' | 'granted' | 'denied'
}

export async function requestPermission() {
    if (!('Notification' in window)) return 'unsupported';
    return Notification.requestPermission();
}

export async function registerSW() {
    if (!('serviceWorker' in navigator)) return null;
    try {
        return await navigator.serviceWorker.register('/sw-notifications.js');
    } catch (err) {
        console.warn('[Notifications] SW registration failed:', err);
        return null;
    }
}

export async function fireNotification(title, body) {
    const reg = await navigator.serviceWorker.ready;
    reg.active.postMessage({
        type: 'SHOW_NOTIFICATION',
        title,
        body,
        tag: 'primemaxing-reminder',
    });
}

export function checkAndFireReminder(complianceData) {
    const settings = loadSettings();
    if (!settings.enabled) return;
    if (getPermissionState() !== 'granted') return;

    const now = new Date();
    const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    if (settings.lastReminderFired === today) return;

    const [h, m] = settings.reminderTime.split(':').map(Number);
    const reminderMinutes = h * 60 + m;
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    if (nowMinutes >= reminderMinutes) {
        // Check if today's protocol is incomplete
        const todayEntry = complianceData?.[today];
        const isComplete = todayEntry?.completedAt != null;

        if (!isComplete && settings.types.dailyReminder) {
            fireNotification(
                'Time for your protocol',
                "Your daily supplements are waiting. Let's keep the streak going."
            );
            saveSettings({ ...settings, lastReminderFired: today });
            console.log('[Notifications] Reminder fired for', today);
        }
    }

    // Return ms until reminder for scheduling a future check
    if (nowMinutes < reminderMinutes) {
        return (reminderMinutes - nowMinutes) * 60 * 1000;
    }
    return null;
}
